export const DISPLAY_DEFAULTS = {
  gradientPreset: 'Default',
  customGradientColors: ['#314e4a', '#2a5a54', '#4a7872', '#0f766e'],
  gradientAngle: -45,
  animationStyle: 'flow',
  patternStyle: 'dots',
  animationOpacity: 0.3,
  animationSpeed: 20,
  patternOpacity: 0.55,
  patternSpeed: 90,
  disableBackgroundEffects: false,
};
